/**
 * @owner @Appboy/user-targeting
 */
import type { AllRouteEndpoints } from "../routeTypes";

export const apiEcommerceEventProperties = "/api/ecommerce/event_properties";

export const apiEcommerceEventPropertiesCacheKeys: AllRouteEndpoints[] = ["/api/ecommerce/event_properties"];
